// Secondary Colors
export const secondaryColorPure = "#0da6f2";
